/* eslint-disable camelcase */

export type RegistrationAnalyticsContext = {
  upgradeRequestId: number | null
  bankidEnabled: boolean | null
  mobywatelEnabled: boolean | null
}

export type RegistrationAnalyticsEventParams = {
  upgrade_request_id?: number
  bankid_enabled?: boolean
  mobywatel_enabled?: boolean
}

let current: RegistrationAnalyticsContext | null = null
let currentStep: string | null = null

export const registrationAnalyticsContextStore = {
  getCurrent: (): RegistrationAnalyticsContext | null => current,
  getCurrentStep: (): string | null => currentStep,
  update: (
    context: RegistrationAnalyticsContext,
    step?: string | null
  ): void => {
    current = context
    if (step !== undefined) {
      currentStep = step
    }
  },
  setCurrentStep: (step: string | null): void => {
    currentStep = step
  },
  clear: (): void => {
    current = null
    currentStep = null
  },
}

export const getRegistrationAnalyticsEventParams =
  (): RegistrationAnalyticsEventParams => {
    const context = registrationAnalyticsContextStore.getCurrent()

    if (!context) {
      return {}
    }

    return {
      ...(context.upgradeRequestId != null && {
        upgrade_request_id: context.upgradeRequestId,
      }),
      ...(context.bankidEnabled != null && {
        bankid_enabled: context.bankidEnabled,
      }),
      ...(context.mobywatelEnabled != null && {
        mobywatel_enabled: context.mobywatelEnabled,
      }),
    }
  }
